import { HTMLAttributes } from 'react'
import styled from 'styled-components'
import {
  border,
  color,
  flexbox,
  layout,
  position,
  space,
  BorderProps,
  ColorProps,
  FlexboxProps,
  LayoutProps,
  PositionProps,
  SpaceProps,
  lineHeight,
  LineHeightProps,
  system,
} from 'styled-system'
import { FetchingStyle, renderFetching } from 'utils/css'

type cursorProps = {
  cursor?: 'default' | 'pointer' | 'not-allowed' | 'grab' | 'grabbing' | 'text'
}

type CssProps = {
  gap?: string
  isFetching?: boolean
  fetchingStyle?: FetchingStyle
  boxSizing?: 'border-box' | 'content-box'
  visibility?: 'visible' | 'hidden' | 'collapse' | 'initial' | 'inherit'
  userSelect?: 'auto' | 'none' | 'text' | 'all' | 'contain'
  transform?: string
}

const transform = system({
  transform: true,
})

export type BoxProps = HTMLAttributes<HTMLDivElement> &
  CssProps &
  BorderProps &
  ColorProps &
  FlexboxProps &
  LayoutProps &
  SpaceProps &
  LineHeightProps &
  PositionProps &
  cursorProps

const Box = styled.div<BoxProps>`
  ${border}
  ${color}
  ${flexbox}
  ${layout}
  ${position}
  ${space}
  ${lineHeight}
  ${transform}
  ${(p) => p.cursor && `cursor: ${p.cursor};`}
  ${(p) => p.gap && `gap: ${p.gap};`}
  ${(p) => p.boxSizing && `box-sizing: ${p.boxSizing};`}
  ${(p) => p.visibility && `visibility: ${p.visibility};`}
  ${(p) => p.userSelect && `user-select: ${p.userSelect};`}
  ${renderFetching}
`

export default Box
